<script setup lang="ts">
const open = defineModel<boolean>()
</script>

<template>
    <div
        class="grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-in-out"
        :class="{ 'grid-rows-[1fr]': open }"
        :aria-expanded="open"
        data-gpp-tools-ui
    >
        <div
            class="overflow-hidden transition-opacity duration-200 ease-linear"
            :class="open ? 'opacity-1 delay-200' : 'opacity-0 delay-500'"
        >
            <slot />
        </div>
    </div>
</template>
